import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import { GetCustomObjectAction } from '../../types/actions/CustomObjectActions';
import { GetCustomObjectQuery } from '../../types/queries/CustomObjectQueries';
import { CustomObjectPayload } from '../../types/payloads/CustomObjectPayloads';

export type CustomObjectActions = {
  getCustomObject: GetCustomObjectAction;
};

export const getCustomObjectActions = (sdk: SDK<ComposableCommerceEventsB2B>): CustomObjectActions => {
  return {
    getCustomObject: async (
      query: GetCustomObjectQuery,
      options?: {
        serverOptions?: ServerOptions;
      },
    ) => {
      const response = await sdk.callAction<CustomObjectPayload>({
        actionName: 'customObject/getCustomObjectByKey',
        query,
        serverOptions: options?.serverOptions,
      });
      return response;
    },
  };
};
